import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { Modal, Button } from 'react-bootstrap';
import logo from "../assets/vitec_logo.png";
import { useTranslation } from 'react-i18next';
import apiClient, { initializeTokens } from "../main/apiClient";
import packageJson from '../../package.json';

type Args = {
    subtitle: string;
    onLogOut: () => void;
};

const Header = ({ subtitle, onLogOut }: Args) => {
  const navigate = useNavigate();
  const { usersName, token, organisationName, setToken, setRefreshToken, setUsersName, setOrganisationId, setOrganisationName } = useContext(AuthContext);
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [serverVersion, setServerVersion] = useState<string | null>(null);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const handleLogout = async () => {
    onLogOut();

    try {
      await apiClient.get('authentication/logout');
      console.log('Logout successful');
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      initializeTokens(null, null);
      setToken('');
      setRefreshToken('');
      setUsersName('');
      setOrganisationId('');
      setOrganisationName('');
      navigate('/login');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  // query server version
  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const version = await apiClient.get(`/version`).then((resp) => resp.data)
        setServerVersion(version);
      } catch (error) {
        console.error('Error fetching version:', error);
      }
    };

    fetchVersion();
  }, []);

  return (
    <>
    <header className="header">
      <div className="container">
        <div className="row align-items-center">
          <div className="col">
            <img src={logo} className="logo mt-3" alt="logo" onClick={() => navigate("/home")} />
            <div className="headerText mt-1" onClick={() => navigate("/home")}>{subtitle}</div>
          </div>
          <>
            {token !== '' && (<div className="col-auto d-flex justify-content-center text-white">
              {usersName} ({organisationName})
            </div>)}
            <div className="col-auto d-flex justify-content-center">
              {i18n.language === 'en' &&
                <>
                  <button className="btn btn-light me-1" onClick={() => changeLanguage('fi')}>Suomeksi</button>
                </>
              }
              {i18n.language === 'fi' &&
                <>
                  <button className="btn btn-light me-1" onClick={() => changeLanguage('en')}>English</button>
                </>
              }
              <button className="btn btn-light me-1" onClick={() => setShowModal(true)}>{t('common.about')}</button>
              <button className="btn btn-dark me-1" disabled={!token} onClick={handleLogout}>{t('common.logout')}</button>
            </div>
          </>
        </div>
        <div>
        </div>
      </div>
      <hr />
    </header>
    <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('common.about')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Management Portal © Vitec Codea Oy 2024 </p>
          <p>Client version {packageJson.version}</p>
          <p>Server version {serverVersion}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleModalClose}>
            {t('buttons.ok')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;
